import React, { createContext, useState, useContext } from 'react'
import ETipoComprovanteExtrato, {
  TipoComprovanteExtrato,
} from '../domain/entities/ETipoComprovanteExtrato'
import {
  ETipoTransacaoPagamento,
  IComprovanteExtrato,
  RecargaCelular,
  TransferenciaP2P,
  TransferenciaTED,
} from '../domain/entities/IComprovantesExtratoResponse'

interface IComprovanteContextState {
  tipoComprovante(tipo: IComprovanteExtrato): string
  transferenciaP2P: TransferenciaP2P
  setTransferenciaP2P(transferenciaP2P: TransferenciaP2P): void
  transferenciaTED: TransferenciaTED
  setTransferenciaTED(transferenciaTED: TransferenciaTED): void
  recargaCelular: RecargaCelular
  setRecargaCelular(recargaCelular: RecargaCelular): void
}

const ComprovanteContext = createContext<IComprovanteContextState>(
  {} as IComprovanteContextState,
)

export function useComprovante(): IComprovanteContextState {
  const context = useContext(ComprovanteContext)

  if (!context) {
    throw new Error('useComprovante must be used within an ComprovanteProvider')
  }

  return context
}

export const ComprovanteProvider: React.FC = ({ children }) => {
  const [transferenciaP2P, setTransferenciaP2P] = useState<TransferenciaP2P>()
  const [transferenciaTED, setTransferenciaTED] = useState<TransferenciaTED>()
  const [recargaCelular, setRecargaCelular] = useState<RecargaCelular>()

  const handleSetTransferenciaP2P = (
    transferenciaP2P: TransferenciaP2P,
  ): void => {
    setTransferenciaP2P(transferenciaP2P)
  }

  const handleSetRecargaCelular = (recargaCelular: RecargaCelular): void => {
    setRecargaCelular(recargaCelular)
  }

  const handleSetTransferenciaTED = (
    transferenciaTED: TransferenciaTED,
  ): void => {
    setTransferenciaTED(transferenciaTED)
  }

  const getTipoComprovante = (tipo: IComprovanteExtrato) => {
    if (tipo[ETipoComprovanteExtrato.TRANSFERENCIA_P2P])
      return TipoComprovanteExtrato.transferenciaP2P
    else if (tipo[ETipoComprovanteExtrato.TRANSFERENCIA_TED])
      return TipoComprovanteExtrato.transferenciaTED
    else if (tipo[ETipoComprovanteExtrato.TRANSACAO_PAGAMENTO])
      return tipo[ETipoComprovanteExtrato.TRANSACAO_PAGAMENTO].tipo ===
        ETipoTransacaoPagamento.BOLETO_PAGAMENTO.toString()
        ? `${TipoComprovanteExtrato.transacaoPagamento} pago`
        : `${TipoComprovanteExtrato.transacaoPagamento} depositado`
    else if (tipo[ETipoComprovanteExtrato.EXTRACAO_DADO])
      return TipoComprovanteExtrato.extracaoDado
    else if (tipo[ETipoComprovanteExtrato.RECARGA_CELULAR])
      return TipoComprovanteExtrato.recargaCelular
  }

  return (
    <ComprovanteContext.Provider
      value={{
        tipoComprovante: getTipoComprovante,
        transferenciaP2P,
        setTransferenciaP2P: handleSetTransferenciaP2P,
        transferenciaTED,
        setTransferenciaTED: handleSetTransferenciaTED,
        recargaCelular,
        setRecargaCelular: handleSetRecargaCelular,
      }}
    >
      {children}
    </ComprovanteContext.Provider>
  )
}
